module.exports = __webpack_public_path__ + "img/icon_notifications.250b37e6.svg";